import React, { useEffect } from "react";
import { CometChat } from "@cometchat-pro/chat";
import {
  AppBar as AppBarMui,
  Avatar,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
} from "@mui/material";
import Logo from "../components/Logo";
import { getAuth, getRedirectResult } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import signInIntoApp, { handleCometChatLogin } from "../util/signInIntoApp";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import app from "../config/firebase";

function AppBar({
  visible = true,
  user,
  setUser,
}: {
  visible: boolean;
  user: CometChat.User | null;
  setUser: React.Dispatch<React.SetStateAction<CometChat.User | null>>;
}) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLogout = () => {
    Promise.all([CometChat.logout(), getAuth().signOut()]).then(() => {
      setUser(null);
      navigate("/");
    });
    setAnchorEl(null);
  };

  useEffect(() => {
    const auth = getAuth(app);
    getRedirectResult(auth).then(res => {
      if (res) {
        handleCometChatLogin(res.user).then((user) => {
          setUser(user as CometChat.User | null);
        });
      }
    });
  }, []);

  return (
    <AppBarMui
      position="static"
      style={{
        backgroundColor: "#6929ca",
        display: visible ? "" : "none",
      }}
    >
      <Toolbar>
        <Logo
          style={{ flexGrow: 1 }}
          svgStyle={{ height: 30, width: "auto" }}
        />
        {user ? (
          <div>
            <IconButton size="large" onClick={handleMenu} color="inherit">
              <Avatar
                sx={{
                  bgcolor: "var(--off-white)",
                  color: "var(--primary)",
                  fontWeight: "bold",
                }}
                alt="Remy Sharp"
                src={user?.getAvatar() || undefined}
              >
                {user?.getName()[0]}
              </Avatar>
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
            >
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </div>
        ) : (
          <Button
            variant="outlined"
            startIcon={<LockOpenIcon />}
            style={{ color: "var(--bgcolor)", borderColor: "white" }}
            onClick={() => {
              signInIntoApp().then((user) => {
                setUser(user as CometChat.User | null);
              });
            }}
          >
            Login
          </Button>
        )}
      </Toolbar>
    </AppBarMui>
  );
}

export default AppBar;
